import React from "react";
import { FaSquarePollHorizontal } from "react-icons/fa6";
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import f1 from "../assets/images/people1.svg";
import f2 from "../assets/images/people2.svg";
import f3 from "../assets/images/people3.svg";
import { useAuth } from "../../src/context/AuthContext";



const follows = [
  {
    name: "Martin Zwilling",
    members: "12.4k",
    posts: "860",
    polls: "4",
    image: f1,
  },
  {
    name: "Rock Music",
    members: "560",
    posts: "32",
    polls: "4",
    image: f2,
  },
  {
    name: "Pizza Lovers",
    members: "22.8k",
    posts: "5.6k",
    polls: "44",
    image: f3,
  },
];

const MyFollow = ({ title = "Suggested Follow" }) => {
  const { isAuthenticated } = useAuth();
  return (
    <div className="suggested-section m-follow">
     <h3 className="mb-15">{title}</h3>
      <div className="suggested-club-card">
            <div className="suggested-club-card-top">
                {follows.map((follow, index) => (
                    <div key={index} className="suggested-club-item">
                            <div className="suggested-club-item-inner">
                                <div className="club-image">
                                    <Image src={follow.image} alt={follow.name}/>
                                </div>
                                
                                <div className="club-content">
                                    <h5>{follow.name}</h5>
                                    <p>{follow.members} followers</p>
                                    <p>
                                        <FaSquarePollHorizontal />
                                        {follow.posts} Posts & {follow.polls} Polls
                                    </p>
                                </div>
                            </div>
                            <Button variant="outline-primary" className="br-10 join" disabled={!isAuthenticated}>
                                Follow
                            </Button>
                    </div>
                    
                ))}

            </div>

            <div className="suggested-club-card-button">
                <Button variant="link">View All</Button>
            </div>
      </div>
    </div>
  );
};

export default MyFollow;
